import React, { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/solid";
import { sidebarOptions } from "./navigation";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  COMPANY_NAME,
  ROLE,
  TOKEN_NAME,
  USERNAME,
  IS_LIVE_TRACKING,
  IS_CHAT,
  REDIRECT_URL,
  SERVICE_KEY,
} from "../config";
import useClickOutside from "../hooks/useClickOutside";
import { Button } from "./ui";
import NavbarDropdown from "./dropdown/navbarDropdown";
import { TbLayoutSidebarLeftCollapseFilled } from "react-icons/tb";
import { TbLayoutSidebarRightCollapseFilled } from "react-icons/tb";

const cookies = new Cookies();

function Sidebar({ show, onClose, isExpanded, expandRetractSidebar }) {
  const [role, setRole] = useState("");
  const [isLiveTracking, setIsLiveTracking] = useState(false);
  const [isChat, setIsChat] = useState(false);

  useEffect(() => {
    setRole(cookies.get(ROLE));
    setIsLiveTracking(cookies.get(IS_LIVE_TRACKING) === "true");
    setIsChat(cookies.get(IS_CHAT) === "true");
  }, []);



  const [attendanceMenuOpen, setAttendanceMenuOpen] = useState(null);
  const handleOpenAttendanceMenu = (value) => {
    setAttendanceMenuOpen(value);
  };

  const handleCloseAttendanceMenu = () => {
    setAttendanceMenuOpen(false);
  };
  const navigate = useNavigate();
  const location = useLocation(); // Get current path

  const isActive = (path) =>
    location.pathname === path
      ? "bg-blue-100 font-semibold "
      : "hover:bg-blue-100 font-semibold";

  const sidebarRef = useClickOutside(() => {
    onClose();
  });

  const handleLogout = () => {
    cookies.remove(TOKEN_NAME);
    cookies.remove(ROLE);
    cookies.remove(USERNAME);
    // navigate("/login");
    window.location.href = `${REDIRECT_URL}?pid=${SERVICE_KEY}`;
  };

  return (
    <div
      ref={sidebarRef}
      className={`bg-white shadow-lg transition-[width] duration-300 ease-in-out lg:block h-[calc(100vh-4rem)] p-4 overflow-auto top-16 z-[1001] right-0 lg:left-0 fixed ${
        show ? "right-0 translate-x-0" : " translate-x-[500px] lg:translate-x-0"
      } ${isExpanded ? "w-64" : "w-64 lg:w-20"}`}
    >
      <div>
        <div
          className={
            "hidden lg:flex " +
            (isExpanded ? "justify-end mb-3 " : "justify-center mb-5")
          }
        >
          <Button
            variant={"ghost"}
            size={"icon"}
            onClick={expandRetractSidebar}
          >
            {isExpanded ? (
              <TbLayoutSidebarLeftCollapseFilled className="w-6 h-6 text-primary" />
            ) : (
              <TbLayoutSidebarRightCollapseFilled className="w-6 h-6 text-primary" />
            )}
          </Button>
        </div>
        <div className="block lg:hidden text-right" onClick={onClose}>
          <Button size={"icon"} variant={"ghost"} aria-label="Close navigation">
            <XIcon className="w-6 h-6 text-primary" />
          </Button>
        </div>

        <div className="gap-5 flex flex-col overflow-auto">
          {sidebarOptions.map((option) => {
            if (
              (option.role === role || option.role === "BOTH") &&
              (!option.feature || (option.feature === "chat" ? isChat : isLiveTracking))
            ) {
              return (
                <Link
                  to={`/${option.name}`}
                  key={option.name}
                  title={!isExpanded ? option.label : undefined}
                  className={`flex text-primary items-center space-x-3 p-2 rounded-lg cursor-pointer ${isActive(
                    `/${option.name}`
                  )} justify-start ${isExpanded ? "lg:justify-start" : "lg:justify-center"}`}
                >
                  {option.icon}
                  <span className={isExpanded ? "" : "lg:hidden"}>{option.label}</span>
                </Link>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
